var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"spinner",staticClass:"spinner",staticStyle:{"height":"100px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }